module.exports = __webpack_public_path__ + "img/2.2a249ec1.png";